import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import AWS from 'aws-sdk';

import { GetCourseById, GetCourseByUser, UpdateFileFinalProjectByCourse } from '../../services/courses';
import { setAnalytics } from '../../utils';
import ReturnButton from '../General/ReturnButton';
import Headers from '../Lessons/Headers';
import PracticalCase from '../Lessons/PracticalCase/PracticalCase';

import SkeletonFinalProject from './SkeletonFinalProject';

const useStyles = makeStyles((theme) => ({
  containerPage: {
    margin: theme.spacing(3, 8),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  containerContent: {
    maxWidth: '80%',
  },
}));
function FinalProject() {
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();

  const [dataCourse, setDataCourse] = useState({});
  const [finalProjectContent, setFinalProjectContent] = useState({});
  const [file, setFile] = useState('');
  const [nameFile, setNameFile] = useState('');
  const [sendFile, setSendFile] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [dataCourseUser, setDatCourseUser] = useState({});
  const [updateLoading, setUpdateLoading] = useState(false);
  const [sizeFile, setSizeFile] = useState(0);

  const S3_BUCKET = process.env.REACT_APP_AWS_BUCKET_KEY;
  const REGION = process.env.REACT_APP_AWS_REGION;

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  });

  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const getDataOfCourse = async () => {
    const courseById = await GetCourseById(location.state.course);
    const courseByUser = await GetCourseByUser(location.state.idUser, location.state.course);
    setDatCourseUser(courseByUser.data[0].finalProjectByUser);
    setSendFile(courseByUser.data[0].finalProjectByUser.file !== undefined);
    setDataCourse(courseById.data);
    setFinalProjectContent(courseById.data.finalProject[0]);
    setIsLoading(false);
  };
  const uploadFileToS3 = async () => {
    try {
      setAnalytics('Lesson', 'Btn_ProyectoFinalEnviado');
      setUpdateLoading(true);
      const params = {
        ACL: 'public-read',
        Body: file,
        Bucket: S3_BUCKET,
        Key: `final-projects-users/${location.state.course}-${
          location.state.idUser
        }.${nameFile.split('.').pop()}`,
      };

      const { Location } = await myBucket.upload(params).promise();
      const dataUpdateFile = {
        idFinalProjectUser: dataCourseUser.id,
        file: Location,
      };
      const responseUpdateFile = await UpdateFileFinalProjectByCourse(dataUpdateFile);
      if (responseUpdateFile.message === 'File of final project sent') {
        setUpdateLoading(false);
        navigate('/finished', {
          state: {
            name: dataCourse.name,
            course: dataCourse.name,
            finalCourse: true,
            theme: false,
          },
        });
      }
      return Location;
    } catch (error) {
      console.log(error.message);
    }
    return location;
  };

  const getFileOfInput = (e) => {
    console.log(file);
    setFile(e.target.files[0]);
    setNameFile(e.target.files[0].name);
    const sizeInMB = e.target.files[0].size / (1024 * 1024);
    setSizeFile(sizeInMB);
  };

  const clearFile = () => {
    setFile('');
    setSizeFile(0);
    setNameFile('');
  };

  useEffect(() => {
    getDataOfCourse();
  }, []);

  return (
    <Box className={classes.containerPage}>
      {isLoading ? (
        <SkeletonFinalProject />
      ) : (
        <>
          <ReturnButton />
          <Box className={classes.container}>
            <Box className={classes.containerContent}>
              <Headers finalProject />
              <PracticalCase
                file={file}
                content={finalProjectContent.description}
                changeInputValue={getFileOfInput}
                nameFile={nameFile}
                isFinalProject
                uploadFileToS3={uploadFileToS3}
                fileSend={sendFile}
                isLoading={updateLoading}
                sizeFile={sizeFile}
                clearFile={clearFile}
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}

export default FinalProject;
